import chat from "@/api/chat";
import axios from 'axios';
import {initRoomWebSocket} from "@/ws/ws_chat";

import {
    SET_ROOMS,
    SET_MESSAGES,
    PUSH_MESSAGE,
    INC_PAGE,
    SET_MESSAGES_LOADED,
    PUSH_MESSAGES,
    CHANGE_ROOM,
    UPDATE_MESSAGE_AFTER_SAVE,
    CHANGE_MESSAGE,
    DELETE_MESSAGE,
    ADD_REACTION,
    REMOVE_REACTION,
    SET_FILE_URL,
    PUSH_FILE_TO_MESSAGE,
    DELETE_FILE,
    UPDATE_MESSAGE_WS, SET_MESSAGE_FAILURE, PUSH_LAST_MESSAGE
} from "@/store/modules/types";


const state = {
    rooms: [],
    roomsLoaded: false,
    lastRoomId: 0,
    roomWebSockets: {},
    messages: [],
    messagesLoaded: false,
    messagesPage: 1
};

const getters = {
    getMessageIdxFromId(state, message_id) {
        return state.messages.findIndex((mes, index, messages) => mes._id === message_id)
    },
    getRoomIdxFromId(state, room_id) {
        return state.rooms.findIndex((room, index, messages) => room.roomId === room_id)
    },
    getMessageIdxFromUri(state, message_uri) {
        return state.messages.findIndex((mes, index, messages) => mes.uri === message_uri)
    },
    getCurrentRoomWebSocket(state) {
        return state.roomWebSockets[state.lastRoomId]
    },
    isReadOnly(state) {
        let roomIdx = getters.getRoomIdxFromId(state, state.lastRoomId);
        if (roomIdx + 1) {
            return !state.rooms[roomIdx].read_only
        }
        return true
    },
    formattedFiles: (state) => (files) => {
        if (files) {
                    const formattedFiles = []
        const timestamp = Date.now();

        files.forEach(file => {
            const messageFile = {
                name: file.name,
                size: file.size,
                type: file.type,
                blob: file.blob,
                extension: file.extension || file.type,
                url: file.url || file.localUrl,
                uri: file.uri || `${file.name}${timestamp}`
            }
            if (file.audio) {
                messageFile.audio = true
                messageFile.duration = file.duration
            }
            formattedFiles.push(messageFile)
        })
        return formattedFiles;
        }
        return null;
    }
};

const actions = {
    getRooms(context) {
        return chat.rooms()
            .then((rooms) => context.commit(SET_ROOMS, rooms.data.results))
            .catch((e) => console.log(e))
    },
    getMessages(context, {room, options}) {
        let roomId = room.roomId;
        if (roomId === context.state.lastRoomId) {//!(options && 'reset' in options)) {
            return chat.messages(roomId, context.state.messagesPage)
            .then((messages) => {
                context.commit(PUSH_MESSAGES, messages.data.results.reverse());
                messages.data.next ? context.commit(INC_PAGE) : context.commit(SET_MESSAGES_LOADED);
            })
            .catch((e) => console.log(e))
        }
        context.commit(CHANGE_ROOM, roomId);

        return chat.messages(roomId, context.state.messagesPage)
            .then((messages) => {
                context.commit(SET_MESSAGES, messages.data.results.reverse());
                messages.data.next ? context.commit(INC_PAGE) : context.commit(SET_MESSAGES_LOADED);
            })
            .catch((e) => console.log(e))
    },
    sendMessage(context, { roomId, message }) {
        context.commit(PUSH_MESSAGE, message);
        context.getters.getCurrentRoomWebSocket.send(JSON.stringify({
            'roomId': roomId,
            'message': message
        }));
    },
    receiveMessage(context, {message, roomUri}) {
        // Получаем сообщение из соккета
        // Проверяем в какую комнату пришло сообщение
        if (roomUri === context.state.lastRoomId) { // если в текущую
            // Проверяем, есть ли сообщение на клиенте
            let mes_idx = getters.getMessageIdxFromUri(state, message.uri)
            if (!(mes_idx + 1)) { // Добавляем новое
                context.commit(PUSH_MESSAGE, message);
            } else { // обновляем
                // Если сообщение новое (id<0)
                if (context.state.messages[mes_idx]._id < 0) {
                    // то проверяем есть ли файлы
                    let files = context.state.messages[mes_idx].files;
                    if (files.length) {
                        // если есть - загружаем на сервер
                        for (let i in files) {
                        chat.send_file(roomUri, message._id, files[i])
                        .then((response) => {
                            context.commit(SET_FILE_URL, {message, response});
                        })
                        .catch((e) => context.commit(SET_MESSAGE_FAILURE, {mes_idx}))
                    }
                    }
                }
                context.commit(UPDATE_MESSAGE_WS, message);
            }
        } else { // Иначе обновляем last_message в списке комнат у той комнаты, куда пришло сообщение
           context.commit(PUSH_LAST_MESSAGE, {message, roomUri})
        }

    },
    editMessage(context, { roomId, messageId, newContent, files, replyMessage, usersTag }) {
        let mes_idx = getters.getMessageIdxFromId(state, messageId);
        let formated_files = context.getters.formattedFiles(files)

        if (formated_files) {
            // Проверяем, появились ли новые файлы
            formated_files.forEach( (formated_file) =>  {
                if (formated_file.url.startsWith('blob')) {
                    context.commit(PUSH_FILE_TO_MESSAGE, {mes_idx, formated_file});
                    chat.send_file(roomId, messageId, formated_file)
                        .then((response) => {
                            let message = context.state.messages[mes_idx];
                            context.commit(SET_FILE_URL, {message, response});

                            context.getters.getCurrentRoomWebSocket.send(JSON.stringify({
                                'roomId': roomId,
                                'message': context.state.messages[mes_idx]
                            }));
                        })
                        .catch((e) => context.commit(SET_MESSAGE_FAILURE, {mes_idx}))
                }
            })
        }
        // Если файлы изменились частично - удаляем файлы, если требуется
        let old_files = context.state.messages[mes_idx].files
        for (let i in old_files) {
            if (!formated_files || !(formated_files.map((f) => f.uri).indexOf(old_files[i].uri) + 1)) {
                chat.delete_file(old_files[i].id)
                    .catch((e) => context.commit(SET_MESSAGE_FAILURE, {mes_idx}))
                context.commit(DELETE_FILE, {mes_idx, file_idx: i});
            }
        }
        context.commit(CHANGE_MESSAGE, {mes_idx, newContent});
        context.getters.getCurrentRoomWebSocket.send(JSON.stringify({
            'roomId': roomId,
            'message': context.state.messages[mes_idx]
        }));
    },
    deleteMessage(context, {roomId, message}) {
        let mes_id = message._id;
        let mes_idx = getters.getMessageIdxFromId(state, mes_id);
        context.commit(DELETE_MESSAGE, {mes_idx});
        context.getters.getCurrentRoomWebSocket.send(JSON.stringify({
            'roomId': roomId,
            'message': context.state.messages[mes_idx]
        }));
        return chat.delete_message(roomId, mes_id)
            .catch((e) => context.commit(SET_MESSAGE_FAILURE, {mes_idx}))
    },
    sendMessageReaction(context, {reaction, remove, messageId, roomId}) {
        let currentUserId = context.rootState.auth.user._id;
        reaction = reaction.unicode;
        let mes_idx = getters.getMessageIdxFromId(state, messageId);


        // смотрим существует ли такая реакция на искомое сообщение
        // Если реакция уже есть
        if (reaction in context.state.messages[mes_idx].reactions) {
            // Получаем её экзмепляр, чтобы узнать id
            chat.get_reaction(messageId, reaction)
                .then((response) => {
                    let reaction_obj = response.data.results[0]
                    if (reaction_obj) {
                        if (remove) { // Либо удаляем реакцию вообще, либо текущего пользователя из отреагировавших
                            if (reaction_obj.users.length > 1) {
                                let user_idx = reaction_obj.users.indexOf(currentUserId);
                                reaction_obj.users.splice(user_idx, 1);
                                chat.put_reaction(reaction_obj)
                                    .catch((e)=> console.log(e))
                            } else chat.delete_reaction(reaction_obj.id)
                                .catch((e)=> console.log(e))
                        } else { // Добавляем текущего пользователя
                            reaction_obj.users.push(currentUserId);
                            chat.put_reaction(reaction_obj)
                                .catch((e)=> console.log(e))
                        }
                    }
                })
                .catch((e) => context.commit(SET_MESSAGE_FAILURE, mes_idx))

        } else { // Создаём новую
            chat.add_reaction(roomId, messageId, currentUserId, reaction)
                .catch((e) => console.log(e))
        }

        // Отображаем реакцию на фронте
        if (remove) {
            context.commit(REMOVE_REACTION, {mes_idx, reaction, currentUserId});
        } else {
            context.commit(ADD_REACTION, {mes_idx, reaction, currentUserId});
        }

        // Передаём в соккет
        context.getters.getCurrentRoomWebSocket.send(JSON.stringify({
            'roomId': roomId,
            'message': context.state.messages[mes_idx]
        }));

    }
};

const mutations = {
    [SET_ROOMS](state, rooms) {
        state.rooms = rooms;
        state.roomsLoaded = true;

        // ws
        rooms.forEach((room) =>{
            state.roomWebSockets[room.roomId] = initRoomWebSocket(room.roomId);
        });
    },
    [CHANGE_ROOM] (state, room_id) {
        state.lastRoomId = room_id;
        state.messagesPage = 1;
    },
    [SET_MESSAGES](state, messages) {
        state.messages = messages;
    },
    [PUSH_MESSAGES](state, messages) {
        // Проверяем, вдруг уже загрузили эти сообщения
        console.log('PUSH MESSAGES!');
        if (messages.length && !(getters.getMessageIdxFromId(state, messages[0]._id) + 1)) {
            messages.push(...state.messages);
            state.messages = messages;
        }
    },
    [PUSH_MESSAGE](state, message) {
        state.messages.push(message);
        state.rooms[getters.getRoomIdxFromId(state, state.lastRoomId)].lastMessage = message;
        // console.log('PUSH');
    },
    [PUSH_LAST_MESSAGE](state, {message, roomUri}){
        state.rooms[getters.getRoomIdxFromId(state, roomUri)].lastMessage = message;
    },
    [INC_PAGE](state) {
        state.messagesPage += 1
        state.messagesLoaded = false;
    },
    [SET_MESSAGES_LOADED](state) {
        state.messagesLoaded = true;
    },
    [UPDATE_MESSAGE_AFTER_SAVE](state, {mes_idx, new_message}) {
        state.messages[mes_idx]._id = new_message._id;
    },
    [UPDATE_MESSAGE_WS](state, message){
        let mes_idx = getters.getMessageIdxFromUri(state, message.uri);
        state.messages[mes_idx]._id = message._id;
        state.messages[mes_idx].saved = message.saved;
    },
    [CHANGE_MESSAGE](state, {mes_idx, newContent}) {
        state.messages[mes_idx].content = newContent;
    },
    [DELETE_MESSAGE](state, {mes_idx}) {
        //state.messages.splice(mes_idx, 1);
        state.messages[mes_idx].deleted = true;
    },
    [SET_MESSAGE_FAILURE](state, mes_idx) {
        state.messages[mes_idx].failure = true;
    },
    [ADD_REACTION](state, {mes_idx, reaction, currentUserId}){
        if (!(reaction in state.messages[mes_idx].reactions)){
            state.messages[mes_idx].reactions[reaction] = [];
        }
        state.messages[mes_idx].reactions[reaction].push(currentUserId);
    },
    [REMOVE_REACTION](state, {mes_idx, reaction, currentUserId}){
        let user_idx = state.messages[mes_idx].reactions[reaction].indexOf(currentUserId);
        state.messages[mes_idx].reactions[reaction].splice(user_idx, 1);
        if (!state.messages[mes_idx].reactions[reaction].length) {
            delete state.messages[mes_idx].reactions[reaction];
        }
    },
    [SET_FILE_URL](state, {message, response}){
        let mes_idx = getters.getMessageIdxFromUri(state, message.uri);
        let old_file_idx = state.messages[mes_idx].files.findIndex((file, index, messages) => response.data.uri === file.uri);
        state.messages[mes_idx].files[old_file_idx].url = response.data.file;
    },
    [PUSH_FILE_TO_MESSAGE](state, {mes_idx, formated_file}){
        state.messages[mes_idx].files.push(formated_file);
    },
    [DELETE_FILE](state, {mes_idx, file_idx}){
        delete state.messages[mes_idx].files[file_idx];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}